import axios from "axios";
import {Dialog} from 'vant';
import nativeApi from '@/utils/native-bridge'

import {
    getToken,
    saveToken,
    removeToken
} from "@/utils/auth";
import {
    Toast
} from "vant";

const reloadPage = function () {
    let href = window.location.href;
    href += (href.indexOf('?') > -1 ? '&' : '?') + `_t=${(Math.random() + '').replace('.', '')}`
    window.location.replace(href);
};

// create an axios instance
const service = axios.create({
    baseURL: process.env.VUE_APP_API_URL // api 的 base_url
})
// request interceptor
service.interceptors.request.use(
    config => {
        if (getToken()) {
            config.headers['Authorization'] = getToken()
        }
        return config
    },
    error => {
        // Do something with request error
        console.error(error) // for debug
        Promise.reject(error)
    }
)

// response interceptor
service.interceptors.response.use(
    /**
     * 下面的注释为通过在response里，自定义code来标示请求状态
     * 当code返回如下情况则说明权限有问题，登出并返回到登录页
     * 如想通过 xmlhttprequest 来状态码标识 逻辑可写在下面error中
     * 以下代码均为样例，请结合自生需求加以修改，若不需要，则可删除
     */
    response => {
        const repObj = response.data
        if (!repObj) {
            return Promise.reject({
                code: -1,
                msg: '未知错误'
            })
        }
        if (repObj.code !== 1) {
            // 50008:非法的token; 50012:其他客户端登录了;  50014:Token 过期了;
            if (repObj.code === 110) {
                removeToken()
                Dialog.close();
                Dialog.alert({
                    title: '温馨提示',
                    message: '加载异常，点击重试',
                }).then(() => {
                    reloadPage()
                });
            } else if (repObj.code === 400) {
                Dialog.close();
                Dialog.confirm({
                    title: '身份认证',
                    message: '此功能需要您身份认证后才可使用，请您先完成身份认证',
                    confirmButtonText: '去认证'
                }).then(() => {
                    nativeApi.forwardPage({uri: window.location.origin + '/bind-personnel', title: '身份认证'})
                    Dialog.confirm({
                        title: '温馨提示',
                        confirmButtonText: '已认证'
                    }).then(() => {
                        reloadPage();
                    }).catch(() => {
                        nativeApi.closePage({})
                    });
                }).catch(() => {
                    nativeApi.closePage({})
                });
            } else if (repObj.code === 404) {
                const action = repObj.data;
                Dialog.close();
                if (!action.forwardUrl) {
                    Dialog.close();
                    Dialog.alert({
                        title: '温馨提示',
                        message: repObj.msg,
                    }).then(() => {
                        nativeApi.closePage();
                    })
                } else {
                    // 需要跳转到下个页面
                    Dialog.confirm({
                        title: '温馨提示',
                        message: action.forwardMessage || repObj.msg,
                        confirmButtonText: action.forwardAction
                    }).then(() => {
                        if (action.forwardUrl.indexOf('http') >= 0) {
                            nativeApi.forwardPage({
                                uri: action.forwardUrl,
                                title: action.forwardTitle
                            })
                        } else {
                            nativeApi.forwardPage({
                                uri: window.location.origin + action.forwardUrl,
                                title: action.forwardTitle
                            })
                        }
                        nativeApi.closePage();
                    }).catch(() => {
                        nativeApi.closePage();
                    })
                }
            } else {
                Dialog.close();
                Dialog.alert({
                    title: '温馨提示',
                    message: repObj.msg,
                }).then(() => {
                })
            }
            return Promise.reject(repObj)
        } else {
            return Promise.resolve(repObj)
        }
    },
    error => {
        const response = error.response
        Toast.fail('请求错误')
        return Promise.reject(error)
    }
)

export default service
